function Academics() {
  return (
    <div className="max-w-7xl mx-auto px-6 py-12">

      {/* Page Title */}
      <h1 className="text-4xl font-bold text-center text-blue-700 mb-10">
        Academics
      </h1>

      {/* Introduction */}
      <div className="text-center max-w-3xl mx-auto mb-12">
        <p className="text-gray-600 text-lg">
          Our academic program follows the CBSE curriculum and focuses on
          developing strong foundational skills in students through
          interactive learning, creativity, and critical thinking.
          We nurture young minds from early childhood through Grade 5.
        </p>
      </div>

      {/* Classes Offered */}
      <div className="mb-12">
        <h2 className="text-2xl font-semibold text-blue-600 mb-6">
          Classes Offered
        </h2>

        <div className="grid md:grid-cols-3 gap-6">

          {[
            "Play Group",
            "Nursery",
            "LKG",
            "UKG",
            "Grade 1",
            "Grade 2",
            "Grade 3",
            "Grade 4",
            "Grade 5"
          ].map((cls, index) => (
            <div
              key={index}
              className="bg-white shadow-md rounded-lg p-6 text-center hover:shadow-lg transition"
            >
              <h3 className="text-lg font-semibold text-gray-800">
                {cls}
              </h3>
            </div>
          ))}

        </div>
      </div>

      {/* Subjects */}
      <div className="mb-12">
        <h2 className="text-2xl font-semibold text-blue-600 mb-6">
          Subjects
        </h2>

        <div className="grid md:grid-cols-3 gap-6">

          {[
            "English",
            "Mathematics",
            "Environmental Studies",
            "General Knowledge",
            "Computer Basics",
            "Art & Craft",
            "Music",
            "Physical Education"
          ].map((subject, index) => (
            <div
              key={index}
              className="bg-blue-50 p-5 rounded-lg text-center font-medium"
            >
              {subject}
            </div>
          ))}

        </div>
      </div>

      {/* Teaching Methodology */}
      <div className="mb-12">

        <h2 className="text-2xl font-semibold text-blue-600 mb-6">
          Teaching Methodology
        </h2>

        <ul className="space-y-3 text-gray-700 list-disc pl-6">

          <li>Activity-based learning</li>
          <li>Smart classroom teaching</li>
          <li>Project-based learning</li>
          <li>Interactive storytelling and phonics</li>
          <li>Hands-on practical activities</li>

        </ul>

      </div>

      {/* Assessment */}
      <div>

        <h2 className="text-2xl font-semibold text-blue-600 mb-6">
          Assessment & Evaluation
        </h2>

        <p className="text-gray-700">
          Students are evaluated through continuous assessments including
          classroom activities, assignments, projects, and periodic
          examinations as per CBSE guidelines. The evaluation system focuses
          on both academic progress and overall development.
        </p>

      </div>

    </div>
  );
}

export default Academics;